import React from "react";
import { Container, Col } from "react-bootstrap";
import { FaUserTie, FaBuilding, FaUsers } from "react-icons/fa";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import "./Statistics.css";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.25, delayChildren: 0.2 },
  },
};

const item = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const Statistics = () => {
  const stats = [
    {
      icon: <FaUsers />,
      count: 18,
      title: "Expert Consultants",
      description: "Specialized consultants with industry expertise",
    },
    {
      icon: <FaBuilding />,
      count: 54,
      title: "Satisfied Clients",
      description: "Trusted by leading companies worldwide",
    },
    {
      icon: <FaUserTie />,
      count: 2160,
      title: "Professionals Placed",
      description:
        "Successfully placed professionals across various industries",
    },
  ].sort((a, b) => a.count - b.count);

  return (
    <section className="statistics-section py-5">
      <Container>
        {/* Heading */}
        <motion.div
          className="section-heading text-center mb-5"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <span className="subtitle text-uppercase">Our Achievements</span>
          <h2 className="display-5 fw-bold gradient-text">
            Building Success Stories Through Exceptional Service
          </h2>
       { /*  <p className="lead text-muted mt-3 w-75 mx-auto">
            We take pride in our accomplishments and the trust our clients place in us.
          </p>  */}
        </motion.div>

        {/* Stats Cards */}
        <motion.div
          className="row g-4 justify-content-center"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {stats.map((stat, index) => (
            <Col lg={4} md={6} key={index}>
              <motion.div
                className="stats-card text-center p-4 h-100 rounded-4 shadow-hover"
                variants={item}
                whileHover={{
                  y: -10,
                  scale: 1.02,
                  transition: { type: "spring", stiffness: 300 },
                }}
              >
                <div className="stat-icon-wrapper mb-3">
                  <div className="stat-icon">{stat.icon}</div>
                </div>

                <div className="stat-count">
                  <CountUp
                    start={0}
                    end={stat.count}
                    duration={2.5}
                    enableScrollSpy
                    scrollSpyOnce
                    separator=","
                  />
                  +
                </div>

                <h3 className="stat-title mt-3">{stat.title}</h3>
                <p className="stat-description">{stat.description}</p>
              </motion.div>
            </Col>
          ))}
        </motion.div>
      </Container>
    </section>
  );
};

export default Statistics;
